const cachedInboundDbImportReferenceResolvers = {};
export const getInboundDbImportReferenceResolver = (resolver, objectTypeId) => {
  const cachedInboundDbImportReferenceResolver = cachedInboundDbImportReferenceResolvers[objectTypeId];
  if (cachedInboundDbImportReferenceResolver) {
    return cachedInboundDbImportReferenceResolver;
  }
  const {
    resolverFactory,
    resolversCache
  } = resolver();
  const InboundDbImportReferenceResolver = resolverFactory(objectTypeId, {});
  const inboundDbImportReferenceResolver = InboundDbImportReferenceResolver(resolversCache);
  cachedInboundDbImportReferenceResolvers[objectTypeId] = inboundDbImportReferenceResolver;
  return inboundDbImportReferenceResolver;
};